import { render, staticRenderFns } from "./CheckboxList.vue?vue&type=template&id=12a755ef&"
import script from "./CheckboxList.ts?vue&type=script&lang=ts&"
export * from "./CheckboxList.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports